import { createSlice } from '@reduxjs/toolkit';


export const dashboardData = createSlice({
  name: 'dashboardData',
  initialState: {
    DashboardDataArray: []
  },
  reducers: {
    setDashboardDataArray: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    // Extra reducer comes here
  }
});

export const { setDashboardDataArray } = dashboardData.actions;
